module.exports = __webpack_public_path__ + "assets/8fd76c34ecfba91dd569cd02bd1b8a30.png";